import {MassMovementGridComponent} from './mass-movement-grid/mass-movement-grid.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BilledComponent } from './billed.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { BilledService } from './billed.service';
import { MyTripsGridModule } from 'app/utils/my-trips-grid/my-trips-grid.module';
import { PaginatorCustomModule } from 'app/utils/paginator-custom/paginator-custom.module';
import { BtnsForGridModule } from 'app/utils/btns-for-grid/btns-for-grid.module';
import { GridLayoutMenuModule } from 'app/utils/grid-layout-menu/grid-layout-menu.module';
import { SummaryGridComponent } from './summary-grid/summary-grid.component';
import { AgGridModule } from 'ag-grid-angular';
import { DenialGridComponent } from './denial-grid/denial-grid.component';
import { BillingScheduledEditModule } from 'app/utils/billing-scheduled-edit/billing-scheduled-edit.module';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { EditReservationModule } from 'app/pages/trip-reservations/edit-reservation/edit-reservation.module';
import { EditBillingModule } from 'app/pages/trip-reservations/edit-reservation/edit-billing/edit-billing.module';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { TripHistoryModule } from 'app/pages/trip-reservations/trip-history/trip-history.module';
import { StandingOrderHistoryModule } from 'app/pages/trip-reservations/standing-order-history/standing-order-history.module';
import { GridComponentsModule } from 'app/pages/A2-utils/grid-components/grid-components.module';
import { BooleanCheckDisabledComponent } from 'app/pages/A2-utils/grid-components/boolean-check-disabled/boolean-check-disabled.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AngularMultiSelectModule,
    FormsModule,
    MyTripsGridModule,
    PaginatorCustomModule,
    BtnsForGridModule,
    GridLayoutMenuModule,
    AgGridModule.withComponents([BooleanCheckDisabledComponent]),
    BillingScheduledEditModule,
    Trip2ThemeModule,
    EditReservationModule,
    EditBillingModule,
    MyDateRangePickerModule,
    TripHistoryModule,
    StandingOrderHistoryModule,
    GridComponentsModule
  ],
  declarations: [BilledComponent, SummaryGridComponent, DenialGridComponent, MassMovementGridComponent],
  exports: [BilledComponent, SummaryGridComponent],
   providers: [BilledService],
   entryComponents: [BooleanCheckDisabledComponent]
})
export class BilledModule { }



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/billed/billed.module.ts